export default __webpack_public_path__ + "static/media/linkedin.931d64c0.svg";